export const initSessionStorageSequenceId = (): void => {
	const sessionStorageSequenceId = window.sessionStorage.getItem("sequenceId");

	if (sessionStorageSequenceId === null) window.sessionStorage.setItem("sequenceId", "0");
};

export const getSessionStorageSequenceId = (): number => Number(window.sessionStorage.getItem("sequenceId"));

export const increaseSequenceId = (): void => {
	// value in session storage always string
	window.sessionStorage.setItem("sequenceId", (getSessionStorageSequenceId() + 1).toString());
};
